import type { CategoryData } from "@hitit/api";
import { getKeyInTranslation } from "../../utils";
import Category from "./Category";
import type StoreItem from "./StoreItem";

export default class Product {

    public categories: Category[]
    public revision: number

    constructor(categories: CategoryData[], revision: number) {
        const sorted = categories.sort((a, b) => a.displaySort - b.displaySort)
        const instances = sorted.map((v) => new Category(v))
        this.categories = instances
        this.revision = revision
    }

    public getNameIdItemLength() {
        return this.categories.map((v) => {
            return {
                uid: v.getId() || "",
                id: v.getId() || "",
                translationDTO: v.getTranslations(),
                childrenLength: v.getStoreItemLength()
            }
        })
    }

    public getCategories() {
        return [...this.categories]
    }

    public findOption(search: string, lang = "ko") {
        const reg = new RegExp(search, "i");
        const items: StoreItem[] = [];

        for (const category of this.categories) {
            const optionItems = category.getStoreItems();

            for (const item of optionItems) {
                if (reg.test(getKeyInTranslation(item.translationDTOs, "name", lang) || "")) {
                    items.push(item)
                }
            }
        }
        return items
    }

    public addNewCategory(category: Category) {
        this.categories = [...this.categories, category]
            .sort((a, b) => a.displaySort - b.displaySort)
    }


    public deleteCategory(category: Category) {
        this.categories = this.categories.filter(v => v !== category)
    }

    public replaceCategoryById(id: string, category: Category) {
        this.categories = [
            ...this.categories.filter(v => v.getId() !== id),
            category
        ]
        return this.sortCategory()
    }
    public sortCategory() {
        this.categories = this.categories
            .sort((a, b) => a.displaySort - b.displaySort)
            .map((v) => {
                v.sortItem()
                return v
            })
        return this
    }

    public updateDisplaysort(oldIndex: number, newIndex: number) {
        if (oldIndex < newIndex) {
            this.categories.splice(newIndex + 1, 0, this.categories[oldIndex]);
            this.categories.splice(oldIndex, 1);
        } else {
            this.categories.splice(newIndex, 0, this.categories[oldIndex]);
            this.categories.splice(oldIndex + 1, 1);
        }

        const updatedCategories: { id: string, newDisplaySort: number }[] = [];

        for (let i = 0; i < this.categories.length; i++) {
            const target = this.categories[i];
            const updatedCategory = {
                id: target.getId() || "",
                newDisplaySort: i
            }

            if (target.displaySort !== i) updatedCategories.push(updatedCategory);
            target.displaySort = i;
        }
        this.sortCategory()

        return updatedCategories
    }
}